import i18n from '../../../../../i18n/i18n';
import {ChartVariant} from '../types/ChartVariant';

export function getXAxisLabel(chartVariant: ChartVariant): string {
  return chartVariant === 'priceMap'
    ? i18n.t('entity.chartOptions.mileage')
    : i18n.t('entity.charts.labels.positionOnMarket');
}
